import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'compact' | 'large';
}
export function CountdownTimer({
  variant = 'compact'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  if (variant === 'large') {
    return <div className="relative inline-block" data-id="element-147">
        {/* Glow effect */}
        <div className="absolute inset-0 bg-red-500/30 rounded-3xl blur-2xl animate-pulse" data-id="element-148" />
        <div className="relative bg-gradient-to-br from-red-600 via-red-700 to-red-900 text-white px-6 py-5 rounded-3xl shadow-2xl border-2 border-red-400/50" data-id="element-149">
          <div className="flex items-center gap-2 justify-center mb-3" data-id="element-150">
            <motion.div animate={{
            scale: [1, 1.2, 1],
            rotate: [0, -10, 10, 0]
          }} transition={{
            duration: 1.5,
            repeat: Infinity
          }} data-id="element-151">
              <Flame className="w-5 h-5 text-yellow-300" data-id="element-152" />
            </motion.div>
            <span className="font-bold text-sm uppercase tracking-widest" data-id="element-153">
              ¡La oferta termina en!
            </span>
            <motion.div animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 10, -10, 0]
          }} transition={{
            duration: 1.5,
            repeat: Infinity
          }} data-id="element-154">
              <Flame className="w-5 h-5 text-yellow-300" data-id="element-155" />
            </motion.div>
          </div>
          <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-156">
            <TimeBlock value={hours} label="HORAS" data-id="element-157" />
            <span className="text-3xl sm:text-4xl font-bold text-yellow-300 -mt-4 animate-pulse" data-id="element-158">
              :
            </span>
            <TimeBlock value={minutes} label="MIN" data-id="element-159" />
            <span className="text-3xl sm:text-4xl font-bold text-yellow-300 -mt-4 animate-pulse" data-id="element-160">
              :
            </span>
            <TimeBlock value={seconds} label="SEG" data-id="element-161" />
          </div>
          <div className="mt-3 text-center text-xs font-medium text-yellow-100/90" data-id="element-162">
            🔥 Después de este tiempo, el precio vuelve a $29.980
          </div>
        </div>
      </div>;
  }
  // Compact variant (default)
  return <motion.div animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    duration: 2,
    repeat: Infinity
  }} className="relative inline-block" data-id="element-163">
      <div className="absolute inset-0 bg-red-500/20 rounded-full blur-xl" data-id="element-164" />
      <div className="relative inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-red-700 text-white px-5 py-3 rounded-full shadow-lg border border-red-400/40" data-id="element-165">
        <motion.div animate={{
        rotate: [0, 15, -15, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} data-id="element-166">
          <Flame className="w-4 h-4 text-yellow-300" data-id="element-167" />
        </motion.div>
        <span className="font-bold text-xs sm:text-sm uppercase tracking-wider" data-id="element-168">
          Termina en:
        </span>
        <div className="flex items-center gap-1 font-bold text-base tabular-nums bg-black/20 px-3 py-1 rounded-full" data-id="element-169">
          <span data-id="element-170">{hours}</span>
          <span className="text-yellow-300 animate-pulse" data-id="element-171">:</span>
          <span data-id="element-172">{minutes}</span>
          <span className="text-yellow-300 animate-pulse" data-id="element-173">:</span>
          <span data-id="element-174">{seconds}</span>
        </div>
      </div>
    </motion.div>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-175">
      <div className="bg-black/40 backdrop-blur-sm rounded-xl px-3 sm:px-4 py-2 sm:py-3 min-w-[64px] sm:min-w-[80px] border border-white/10 shadow-inner" data-id="element-176">
        <motion.div key={value} initial={{
        y: -20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.3
      }} className="text-3xl sm:text-5xl font-bold tabular-nums leading-none text-white" style={{
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-177">
          {value}
        </motion.div>
      </div>
      <span className="text-[10px] sm:text-xs font-bold text-yellow-200 mt-2 tracking-widest" data-id="element-178">
        {label}
      </span>
    </div>;
}